import LeftSectionBlock from "../../components/LeftSectionBlock";
import RightSectionBlock from "../../components/RightSectionBlock";
import ResponsiveImageMapRecruitment from "../../components/ResponsiveImageMapRecruitment";
import RecruitmentBG from "../../assets/images/recruitmentbg.svg";
import Accordion from "../../components/Accordion";

const areas = [
  {
    shape: "circle",
    coords: "25,540,20",
    alt: "process1",
    color: "rgba(0, 0, 255,0)",
    className: "pre-screen-bubble-hover-blk",
  },
  {
    shape: "circle",
    coords: "272,425,20",
    alt: "process2",
    color: "rgba(0, 0, 255,0)",
    className: "resume-screen-bubble-hover-blk",
  },

  {
    shape: "circle",
    coords: "386,253,23",
    alt: "process3",
    color: "rgba(0, 0, 255,0)",
    className: "qualifying-screen-bubble-hover-blk",
  },
  {
    shape: "circle",
    coords: "520,200,23",
    alt: "process4",
    color: "rgba(0, 0, 255,0)",
    className: "cognitive-assesstment-bubble-hover-blk",
  },
  {
    shape: "circle",
    coords: "665,140,23",
    alt: "process5",
    color: "rgba(0, 0, 255,0)",
    className: "culture-fit-bubble-hover-blk",
  },
  {
    shape: "circle",
    coords: "819,32,23",
    alt: "process6",
    color: "rgba(0, 0, 255,0)",
    className: "meet-greet-bubble-hover-blk",
  },
];

const sections = [
  {
    title: "Average Applicants ",
    content: (
      <div className="content-accordion">
        <b>500 Pre-Screen</b>
        <ul>
          <li>
            <p>Minimum requirements</p>
          </li>
          <li>
            <p>Salary expectations</p>
          </li>
          <li>
            <p>Years of experience</p>
          </li>
          <li>
            <p>Availability</p>
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Screened",
    content: (
      <div className="content-accordion">
        <b>Resume Screen</b>
        <ul>
          <li>
            <p>Skills and qualifications</p>
          </li>
          <li>
            <p>Relevant work experience</p>
          </li>
          <li>
            <p>Educational background</p>
          </li>
          <li>
            <p>Job-specific criteria</p>
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Qualifying Interview",
    content: (
      <div className="content-accordion">
        <ul>
          <li>
            <p>Problem-solving approach</p>
          </li>
          <li>
            <p>Motivation and passion</p>
          </li>
          <li>
            <p>Technical competencies verification</p>
          </li>
          <li>
            <p>Salary expectations clarification</p>
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Cognitive Assessment",
    content: (
      <div className="content-accordion">
        <ul>
          <li>
            <p>Communication skills</p>
          </li>
          <li>
            <p>Comprehension</p>
          </li>
          <li>
            <p>Attention to detail</p>
          </li>
          <li>
            <p>Reasoning ability</p>
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Culture Fit Interview",
    content: (
      <div className="content-accordion">
        <ul>
          <li>
            <p>iCXeed DNA and values alignment</p>
          </li>
          <li>
            <p>Client culture fit</p>
          </li>
          <li>
            <p>Learning agility and innovation quotient</p>
          </li>
          <li>
            <p>Long-term potential</p>
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Client Meet & Greet",
    content: (
      <div className="content-accordion">
        <ul>
          <li>
            <p>Client persona fit</p>
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Hired",
    content: (
      <div className="content-accordion">
        <ul>
          <li>
            <p>1 Applicant Hired!</p>
          </li>
        </ul>
      </div>
    ),
  },
];

const MainContent = () => {
  return (
    <>
      <div className="our-dna-container-blk">
        <ResponsiveImageMapRecruitment
          src={RecruitmentBG}
          alt="Recruitment"
          mapName="recruitment"
          areas={areas}
        />
      </div>
      <div className="our-dna-container-mobile">
        <img src={RecruitmentBG} />
        <Accordion sections={sections} />
      </div>
    </>
  );
};

const RecruitmentProcessPage = () => {
  return (
    <div className="main-container-blk">
      <div className="main-section-blk">
        <LeftSectionBlock />
        <RightSectionBlock
          title="RECRUITMENT PROCESS"
          stringBlurb="Our talent acquisition process is designed to identify and attract
              top talent who embody our DNA, We pride ourselves on our ability
              to recruit individuals who not only have the technical skills
              required but also align with our unique culture and approach to
              business process innovation (BPI)."
          previousBtn="/our-dna"
          nextBtn="/new-expert-orientation"
          mainContent={<MainContent />}
        />
      </div>
    </div>
  );
};

export default RecruitmentProcessPage;
